import { create } from "zustand";
import { ZoneId } from "@js-joda/core";
import { Locale } from "date-fns/types";
import { registerLocale } from "react-datepicker";
import { LEGACY_TZ_KEY } from "hooks/useTimezone";
import { UserDTO } from "../api/model/user/UserDTO";
import { CompanyDTO } from "../api/model/company/CompanyDTO";
import { BROWSER_ZONE_ID } from "../utils/time-utils";
import { getLocale } from "../utils/utils";


const COMPANY_TZ_LOCALSTORAGE_KEY = "_tmp_companyTimezones";
const DISPLAY_TZ_LOCALSTORAGE_KEY = "_tmp_displayTimezone";

export interface UserState {
  companyContext?: CompanyDTO;
  currentUser?: UserDTO;
  isCurrentUserLoaded: boolean;
  setCompanyContext: (company?: CompanyDTO) => void;
  setCurrentUser: (user?: UserDTO) => void;
  getLanguage: () => string;
  getLocaleDateFns: () => Locale;

  getDisplayTimezone: () => string;
  getDisplayZoneId: () => ZoneId;
  setDisplayTimezone: (timezone?: string) => void;
  getCompanyTimezone: () => string;
  getCompanyZoneId: () => ZoneId;
  setCompanyTimezone: (timezone?: string) => void;
}

export const useUserState = create<UserState>()((set, get) => ({
  companyContext: undefined,
  currentUser: undefined,
  isCurrentUserLoaded: false,
  setCompanyContext: (company?: CompanyDTO) => set(() => ({ companyContext: company })),
  setCurrentUser: (user?: UserDTO) => {
    set(() => ({
      currentUser: user,
      isCurrentUserLoaded: true,
      companyContext: user?.accessibleCompanies.filter(c => user?.companyRef === c.companyReference)[0],
    }));
  },
  getLanguage: () => get().currentUser?.preferences.language || "en",
  getLocaleDateFns: () => {
    const locale = getLocale(get().getLanguage());
    registerLocale(get().getLanguage(), locale);
    return locale;
  },

  // getDisplayTimezone: () => get().currentUser?.preferences.timezone || get().getCompanyTimezone(),
  getDisplayTimezone: () => {
    return localStorage.getItem(DISPLAY_TZ_LOCALSTORAGE_KEY) || LEGACY_TZ_KEY;
  },
  getDisplayZoneId: () => parseZoneId(get().getDisplayTimezone()),
  // setDisplayTimezone: (timezone?: string) => {
  //     const user = get().currentUser
  //     if (user) {
  //         user.preferences = {
  //             ...user.preferences,
  //             timezone: timezone
  //         }
  //         set(() => ({
  //             currentUser: user
  //         }))
  //     }
  // },
  setDisplayTimezone: (timezone?: string) => {
    localStorage.setItem(DISPLAY_TZ_LOCALSTORAGE_KEY, timezone || "");

    // Update a dummy field to trigger rerender
    set(() => ({
      companyContext: get().companyContext,
    }));
  },

  // getCompanyTimezone: () => get().companyContext?.timezone || BROWSER_TIMEZONE,
  getCompanyTimezone: () => {
    const company = get().companyContext?.companyReference!!;
    const objStr = localStorage.getItem(COMPANY_TZ_LOCALSTORAGE_KEY) || "";
    let obj = {} as any;

    if (!objStr) {
      return LEGACY_TZ_KEY;
    }

    try {
      obj = JSON.parse(objStr);
    } catch (e) {
      console.error("Error parsing company timezone from localStorage", e);
    }

    return obj[company] || LEGACY_TZ_KEY;
  },
  getCompanyZoneId: () => parseZoneId(get().getCompanyTimezone()),
  // setCompanyTimezone: (timezone?: string) => {
  //     const company = get().companyContext
  //     if (company) {
  //         company.timezone = timezone
  //         set(() => ({
  //             companyContext: company
  //         }))
  //     }
  // },
  // TODO: remove this
  setCompanyTimezone: (timezone?: string) => {
    const company = get().companyContext?.companyReference!!;
    const obj = {} as any;
    obj[company] = timezone;
    localStorage.setItem(COMPANY_TZ_LOCALSTORAGE_KEY, JSON.stringify(obj));

    // Update a dummy field to trigger rerender
    set(() => ({
      companyContext: get().companyContext,
    }));
  },
}));

const parseZoneId = (tz: string | undefined): ZoneId => {
  if (!tz || tz === LEGACY_TZ_KEY || tz === "_BROWSER_") {
    return BROWSER_ZONE_ID;
  }

  return ZoneId.of(tz);
};

export const initUser = () => {
  console.log(`Initializing user context...`);
  const user = window.userInfo;
  useUserState.getState().setCurrentUser(user);
  console.log(`User context initialized`, useUserState.getState());
};